import { Button, Link } from '@heroui/react';

export const CartListStatus = ({
  variant = 'empty',
}: {
  variant?: 'empty';
}) => {
  if (variant === 'empty') {
    return (
      <div className="flex flex-col items-center h-full justify-center text-[#9CA5AC] text-sm">
        <p className="text-[#222222] font-semibold text-lg lg:text-xl text-center">
          В корзине пусто
        </p>
        <p className="text-[#60656C] text-sm lg:text-base text-center max-w-60 lg:max-w-72 mt-3 lg:mt-4">
          Добавьте товары, чтобы начать процесс оформления заказа
        </p>
        <Button
          color="primary"
          size="lg"
          className="mt-6 lg:mt-9 lg:w-72"
          as={Link}
          href="/"
        >
          На главную
        </Button>
      </div>
    );
  }
  return null;
};
